import { PERIOD_GROUPING_FIELD_NAME } from "../../constants";
import { ReportPeriodGroupingEnum } from "../../enums";
import { IReportColumn, IReportCriteriaApi } from "../../models";
import { isSubsetArray } from "../array.helpers";

export const getIsFlexPeriodGroupingApplied = (
  periodGroupingColumn: IReportColumn | undefined,
  criteria?: IReportCriteriaApi,
): boolean => {
  const periodGrouping = criteria?.flexGrouping?.periodGrouping;

  if (
    !periodGrouping ||
    periodGrouping === ReportPeriodGroupingEnum.EntirePeriod ||
    !periodGroupingColumn
  ) {
    return false;
  }

  return true;
};

export const isReportDynamicColumnSetChanged = ({
  visibleColumnsReport,
  groupingParams,
  isFlexPeriodTemplateApplied,
}: {
  visibleColumnsReport: string[] | undefined;
  groupingParams: string[] | undefined;
  isFlexPeriodTemplateApplied: boolean;
}): boolean => {
  if (!visibleColumnsReport?.length) {
    return false;
  }

  const computedArray = [...(groupingParams || [])];

  if (isFlexPeriodTemplateApplied) {
    computedArray.push(PERIOD_GROUPING_FIELD_NAME);
  }

  return !isSubsetArray(computedArray, visibleColumnsReport);
};
